module.exports = __webpack_public_path__ + "media/images/ready/icon-facetime-b47a6654fa9b7520df0d6939c8323bfd.svg";